import React from 'react';
import { COUNSELLOR_OVERLAY_CONFIG } from './counsellorOverlayConfig';
import './CounsellorsOverlay.css';

function CounsellorsOverlay({ t, variant = 'counsellor-freeform' }) {
  const config = COUNSELLOR_OVERLAY_CONFIG[variant] || COUNSELLOR_OVERLAY_CONFIG['counsellor-freeform'];
  const hasStructuredFreeformCopy = (
    variant === 'counsellor-freeform' &&
    t('counsellors_freeform_intro') !== 'counsellors_freeform_intro'
  );
  const hasStructuredEvokeCopy = (
    variant === 'counsellor-evoke' &&
    t('counsellors_evoke_intro') !== 'counsellors_evoke_intro'
  );

  if (hasStructuredFreeformCopy) {
    return (
      <div className="overlay-article">
        <h2 id="overlay-heading" className="about-title">{t(config.titleKey)}</h2>
        <article className="article-content">
          <p className="article-intro">{t('counsellors_freeform_intro')}</p>
          <section>
            <h3>{t('counsellors_freeform_section_architecture_title')}</h3>
            <p>{t('counsellors_freeform_section_architecture_p1')}</p>
            <p>{t('counsellors_freeform_section_architecture_p2')}</p>
            <figure className="overlay-figure counsellor-overlay-figure">
              <div className="counsellor-overlay-grid counsellor-overlay-grid--pipeline">
                <div className="counsellor-overlay-card">
                  <h4>{t('counsellors_freeform_figure_prompt_title')}</h4>
                  <p>{t('counsellors_freeform_figure_prompt_body')}</p>
                </div>
                <div className="counsellor-overlay-arrow" aria-hidden="true">→</div>
                <div className="counsellor-overlay-card">
                  <h4>{t('counsellors_freeform_figure_model_title')}</h4>
                  <p>{t('counsellors_freeform_figure_model_body')}</p>
                </div>
                <div className="counsellor-overlay-arrow" aria-hidden="true">→</div>
                <div className="counsellor-overlay-card counsellor-overlay-accent-card">
                  <h4>{t('counsellors_freeform_figure_observers_title')}</h4>
                  <p>{t('counsellors_freeform_figure_observers_body')}</p>
                </div>
              </div>
              <figcaption className="overlay-figure-caption">
                {t('counsellors_freeform_figure_architecture_caption')}
              </figcaption>
            </figure>
          </section>
          <section>
            <h3>{t('counsellors_freeform_section_iteration_title')}</h3>
            <p>{t('counsellors_freeform_section_iteration_p1')}</p>
            <p>{t('counsellors_freeform_section_iteration_p2')}</p>
          </section>
          <section>
            <h3>{t('counsellors_freeform_section_evidence_title')}</h3>
            <p>{t('counsellors_freeform_section_evidence_p1')}</p>
            <p>{t('counsellors_freeform_section_evidence_p2')}</p>
            <figure className="overlay-figure counsellor-overlay-figure">
              <div className="counsellor-overlay-grid counsellor-overlay-grid--metrics">
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">106</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_freeform_metric_participants_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_freeform_metric_participants_note')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">+1.7</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_freeform_metric_confidence_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_freeform_metric_confidence_note')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">98%</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_freeform_metric_mic_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_freeform_metric_mic_note')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">42</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_freeform_metric_care_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_freeform_metric_care_note')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">59%</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_freeform_metric_ct_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_freeform_metric_ct_note')}</p>
                </div>
              </div>
              <figcaption className="overlay-figure-caption">
                {t('counsellors_freeform_figure_metrics_caption')}
              </figcaption>
            </figure>
            <figure className="overlay-figure counsellor-overlay-figure">
              <div className="counsellor-overlay-track">
                <div className="counsellor-overlay-track-bars">
                  <div className="counsellor-overlay-track-bar counsellor-overlay-track-bar--confidence">
                    <span className="counsellor-overlay-track-label">{t('counsellors_freeform_track_label')}</span>
                    <div className="counsellor-overlay-track-line" aria-hidden="true">
                      <svg viewBox="0 0 160 88" preserveAspectRatio="none">
                        <path d="M6 60 C34 58, 58 50, 82 40 S124 22, 154 16" />
                      </svg>
                    </div>
                  </div>
                  <div className="counsellor-overlay-track-bar counsellor-overlay-track-bar--hybrid">
                    <span className="counsellor-overlay-track-label">{t('counsellors_freeform_track_baseline_label')}</span>
                    <div className="counsellor-overlay-track-line" aria-hidden="true">
                      <svg viewBox="0 0 160 88" preserveAspectRatio="none">
                        <path d="M6 64 C34 61, 58 56, 82 48 S124 34, 154 28" />
                      </svg>
                    </div>
                  </div>
                </div>
                <figcaption className="counsellor-overlay-track-caption">
                  {t('counsellors_freeform_track_caption')}
                </figcaption>
              </div>
            </figure>
          </section>
          <section>
            <h3>{t('counsellors_freeform_section_aimie_title')}</h3>
            <p>{t('counsellors_freeform_section_aimie_p1')}</p>
            <p>{t('counsellors_freeform_section_aimie_p2')}</p>
          </section>
        </article>
      </div>
    );
  }

  if (hasStructuredEvokeCopy) {
    return (
      <div className="overlay-article">
        <h2 id="overlay-heading" className="about-title">{t(config.titleKey)}</h2>
        <article className="article-content">
          <p className="article-intro">{t('counsellors_evoke_intro')}</p>
          <section>
            <h3>{t('counsellors_evoke_section_architecture_title')}</h3>
            <p>{t('counsellors_evoke_section_architecture_p1')}</p>
            <p>{t('counsellors_evoke_section_architecture_p2')}</p>
            <figure className="overlay-figure counsellor-overlay-figure">
              <div className="counsellor-overlay-grid counsellor-overlay-grid--pipeline">
                <div className="counsellor-overlay-card">
                  <h4>{t('counsellors_evoke_figure_signal_title')}</h4>
                  <p>{t('counsellors_evoke_figure_signal_body')}</p>
                </div>
                <div className="counsellor-overlay-arrow" aria-hidden="true">→</div>
                <div className="counsellor-overlay-card">
                  <h4>{t('counsellors_evoke_figure_selector_title')}</h4>
                  <p>{t('counsellors_evoke_figure_selector_body')}</p>
                </div>
                <div className="counsellor-overlay-arrow" aria-hidden="true">→</div>
                <div className="counsellor-overlay-card counsellor-overlay-accent-card">
                  <h4>{t('counsellors_evoke_figure_generation_title')}</h4>
                  <p>{t('counsellors_evoke_figure_generation_body')}</p>
                </div>
              </div>
              <figcaption className="overlay-figure-caption">
                {t('counsellors_evoke_figure_architecture_caption')}
              </figcaption>
            </figure>
          </section>
          <section>
            <h3>{t('counsellors_evoke_section_stages_title')}</h3>
            <p>{t('counsellors_evoke_section_stages_p1')}</p>
            <p>{t('counsellors_evoke_section_stages_p2')}</p>
            <figure className="overlay-figure counsellor-overlay-figure">
              <div className="counsellor-overlay-grid counsellor-overlay-grid--metrics counsellor-overlay-grid--triple">
                <div className="counsellor-overlay-card counsellor-overlay-stage-card">
                  <span className="counsellor-overlay-stage-index">1</span>
                  <h4>{t('counsellors_evoke_stage_one_title')}</h4>
                  <p>{t('counsellors_evoke_stage_one_body')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-stage-card">
                  <span className="counsellor-overlay-stage-index">2</span>
                  <h4>{t('counsellors_evoke_stage_two_title')}</h4>
                  <p>{t('counsellors_evoke_stage_two_body')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-stage-card">
                  <span className="counsellor-overlay-stage-index">3</span>
                  <h4>{t('counsellors_evoke_stage_three_title')}</h4>
                  <p>{t('counsellors_evoke_stage_three_body')}</p>
                </div>
              </div>
              <figcaption className="overlay-figure-caption">
                {t('counsellors_evoke_figure_stages_caption')}
              </figcaption>
            </figure>
          </section>
          <section>
            <h3>{t('counsellors_evoke_section_evidence_title')}</h3>
            <p>{t('counsellors_evoke_section_evidence_p1')}</p>
            <p>{t('counsellors_evoke_section_evidence_p2')}</p>
            <figure className="overlay-figure counsellor-overlay-figure">
              <div className="counsellor-overlay-grid counsellor-overlay-grid--metrics">
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">0.99</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_evoke_metric_end_goal_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_evoke_metric_end_goal_note')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">3.98</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_evoke_metric_stage_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_evoke_metric_stage_note')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">5.1</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_evoke_metric_change_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_evoke_metric_change_note')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">18.5</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_evoke_metric_turns_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_evoke_metric_turns_note')}</p>
                </div>
                <div className="counsellor-overlay-card counsellor-overlay-metric-card">
                  <span className="counsellor-overlay-metric-value">0.46</span>
                  <span className="counsellor-overlay-metric-label">{t('counsellors_evoke_metric_reveal_label')}</span>
                  <p className="counsellor-overlay-metric-note">{t('counsellors_evoke_metric_reveal_note')}</p>
                </div>
              </div>
              <figcaption className="overlay-figure-caption">
                {t('counsellors_evoke_figure_metrics_caption')}
              </figcaption>
            </figure>
            <figure className="overlay-figure counsellor-overlay-figure">
              <div className="counsellor-overlay-track">
                <div className="counsellor-overlay-track-bars">
                  <div className="counsellor-overlay-track-bar counsellor-overlay-track-bar--confidence">
                    <span className="counsellor-overlay-track-label">{t('counsellors_evoke_track_label')}</span>
                    <div className="counsellor-overlay-track-line" aria-hidden="true">
                      <svg viewBox="0 0 160 88" preserveAspectRatio="none">
                        <path d="M6 70 C30 68, 46 52, 70 36 S118 12, 154 8" />
                      </svg>
                    </div>
                  </div>
                  <div className="counsellor-overlay-track-bar counsellor-overlay-track-bar--hybrid">
                    <span className="counsellor-overlay-track-label">{t('counsellors_evoke_track_baseline_label')}</span>
                    <div className="counsellor-overlay-track-line" aria-hidden="true">
                      <svg viewBox="0 0 160 88" preserveAspectRatio="none">
                        <path d="M6 70 C32 67, 54 61, 78 54 S122 44, 154 38" />
                      </svg>
                    </div>
                  </div>
                </div>
                <figcaption className="counsellor-overlay-track-caption">
                  {t('counsellors_evoke_track_caption')}
                </figcaption>
              </div>
            </figure>
          </section>
          <section>
            <h3>{t('counsellors_evoke_section_aimie_title')}</h3>
            <p>{t('counsellors_evoke_section_aimie_p1')}</p>
            <p>{t('counsellors_evoke_section_aimie_p2')}</p>
          </section>
        </article>
      </div>
    );
  }

  return (
    <div className="overlay-article">
      <h2 id="overlay-heading" className="about-title">{t(config.titleKey)}</h2>
      <article className="article-content">
        {t(config.bodyKey).split('\n\n').map((paragraph, index) => (
          <p
            key={`${variant}-${index}`}
            className={index === 0 ? 'counsellors-intro-first' : undefined}
          >
            {paragraph}
          </p>
        ))}
      </article>
    </div>
  );
}

export default CounsellorsOverlay;
